import React, { useEffect, useState } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  workingBudgetData,
  additionalCostData
} from '../../GlobalState';
import { TableItemRow } from './TableItemRow';
import { TypeRow } from '../../types/WorkingBudgetPage';
import { LAYER_LIST } from '../../const/WorkingBudgetPage';
import {
  LOCAL_WORKING_BUDGET_KEY,
  LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY
} from '../../const/Const';
import { useParams } from 'react-router-dom';

type TProps = {
  isDetailShow: boolean;
  data?: TypeRow;
  layer_key?: string;
  indent?: number;
  bankName?: string;
  workingBudgetId: number;
  reflectData: boolean;
};

/**
 * テーブルヘッダー
 * @constructor
 */
export const ItemTableBody: React.FC<TProps> = (props: TProps) => {
  const {
    isDetailShow,
    data,
    layer_key = LAYER_LIST.FIRST,
    indent = 1,
    bankName = '',
    workingBudgetId,
    reflectData
  } = props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });
  const [dataList, setDataList] = useState<TypeRow[]>([]);
  const [workingBudget, setWorkingBudget] = useRecoilState(workingBudgetData);
  const [additionalCost, setAdditionalCost] =
    useRecoilState(additionalCostData);
  const params: any = useParams();

  const setKey = params.id
    ? LOCAL_WORKING_BUDGET_KEY + params.id
    : LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY + workingBudgetId;

  useEffect(() => {
    if (workingBudget) {
      if (layer_key == LAYER_LIST.FIRST) {
        setDataList(workingBudget ? workingBudget[layer_key] : []);
      } else {
        const layerFullData: TypeRow[] = workingBudget[layer_key];
        const layerData = data
          ? layerFullData.filter(i => i.parent_item_id == data.id)
          : [];
        setDataList(layerData);
      }
    }
  }, [workingBudget]);

  useEffect(() => {
    if (reflectData) {
      // ローカルストレージデータを取得
      const localStorageData = localStorage.getItem(setKey);
      if (localStorageData) {
        // ローカルストレージから取得したデータが存在する場合
        const parsedData = JSON.parse(localStorageData);
        const workingBudget = parsedData.workingBudget;
        // workingBudgetを更新
        setWorkingBudget(workingBudget);
      }
    }
  }, [reflectData]);

  return (
    <>
      {dataList &&
        dataList.length > 0 &&
        dataList.map((data, index) => (
          <TableBody
            isDetailShow={isDetailShow}
            data={data}
            indent={indent}
            layer_key={layer_key}
            bankName={bankName}
            key={index}
            workingBudgetId={workingBudgetId}
            reflectData={reflectData}
          />
        ))}
    </>
  );
};

type TTableBodyProps = {
  isDetailShow: boolean;
  data: TypeRow;
  indent: number;
  layer_key: string;
  bankName: string;
  workingBudgetId: number;
  reflectData: boolean;
};

const TableBody: React.FC<TTableBodyProps> = (props: TTableBodyProps) => {
  const {
    isDetailShow,
    data,
    indent,
    layer_key,
    bankName,
    workingBudgetId,
    reflectData
  } = props;

  const [open, setOpen] = useState(false);

  const processingBankName =
    bankName == '' ? data.name : bankName + ' ＞ ' + data.name;

  return (
    <>
      <TableItemRow
        isDetailShow={isDetailShow}
        data={data}
        indent={indent + 1}
        open={open}
        setOpen={setOpen}
        layer_key={layer_key}
        bankName={processingBankName}
        workingBudgetId={workingBudgetId}
      />
      {open && data.has_under_layer_flg == 1 && (
        <ItemTableBody
          isDetailShow={isDetailShow}
          data={data}
          indent={indent + 1}
          layer_key={`layer${indent + 1}`}
          bankName={processingBankName}
          workingBudgetId={workingBudgetId}
          reflectData={reflectData}
        />
      )}
    </>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({})
);
